import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import EmailIcon from '@material-ui/icons/Email';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import emailjs from 'emailjs-com';
import React from 'react';

const Contact = ({ page }) => {
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_wcwslxb', 'template_v42m1yb', e.target, '8mfha8J-lEJgleTqT')
            .then((result) => {
                alert("Mail send successfully");
            }, (error) => {
                alert(error.text);
            });
    }

    return (
        <div className='header_area contact_area'>
            <div className='container'>
                {page ?
                    <div id="processTitle" className=' pb-5'>
                        <h5>Contact</h5>
                        <h2>Contact with me</h2>
                    </div>
                    : ''}
                <div className="row align-items-center">
                    <div className="col-md header_about_me">
                        <h3>Get In Touch</h3>
                        <p>
                            I'd love to hear from you. Whether you have a question or just want to say hi, feel free to drop a message. I'll try my best to get back to you!
                        </p>
                        <div>
                            <a href="https://www.linkedin.com/in/mahbubdev1/" target="_blank" rel="noopener noreferrer">
                                <LinkedInIcon className="icon" />
                            </a>
                            <a href="https://github.com/mahbub-hasan2" target="_blank" rel="noopener noreferrer">
                                <GitHubIcon className="icon" />
                            </a>
                            <a href="mailto:mahbubdev1@gmail.com">
                                <EmailIcon className="icon" />
                            </a>
                            <a href="/">
                                <AddIcCallIcon className="icon" />
                            </a>
                        </div>
                    </div>
                    <div className="col-md">
                        <form onSubmit={sendEmail}>
                            {/* <!-- Name input --> */}
                            <div className="form-outline mb-4">
                                <input name="name" type="text" id="form4Example1" className="form-control" />
                                <label className="form-label" htmlFor="form4Example1">Name</label>
                            </div>

                            {/* <!-- Email input --> */}
                            <div className="form-outline mb-4">
                                <input name="email" type="email" id="form4Example2" className="form-control" />
                                <label className="form-label" htmlFor="form4Example2">Email address</label>
                            </div>

                            {/* <!-- Message input --> */}
                            <div className="form-outline mb-4">
                                <textarea name="message" className="form-control" id="form4Example3" rows="4"></textarea>
                                <label className="form-label" htmlFor="form4Example3">Message</label>
                            </div>

                            {/* <!-- Checkbox --> */}
                            {/* <div className="form-check d-flex justify-content-center mb-4">
                                <input className="form-check-input me-2" type="checkbox" value="" id="form4Example4" defaultChecked />
                                <label className="form-check-label" htmlFor="form4Example4">
                                Send me a copy of this message
                                </label>
                            </div> */}

                            {/* <!-- Submit button --> */}
                            <button type="submit" className="btn btn-primary btn-block mb-4">Send</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;